import { helper } from '@ember/component/helper';
import { get } from '@ember/object';

/**
 * Legge un valore da un oggetto usando un path
 */
var readPath = helper(([object, path]) => {
  if (!object || typeof path !== 'string') return null;
  return get(object, path);
});

export { readPath as default };
//# sourceMappingURL=read-path.js.map
